import { useTranslation } from 'react-i18next';
import { Anchor, Box, Container, Group, Image, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import Petal from '@/components/landing/Petal';

const RUSTORE_URL = 'https://www.rustore.ru/catalog/app/com.graintrade.forwarder';

interface MobileBenefit {
  readonly key: string;
  readonly icon: string;
}

const BENEFITS: readonly MobileBenefit[] = [
  { key: 'seamless', icon: 'process' },
  { key: 'exchange', icon: 'arrow-both-side' },
];

// Приложение для экспедиторов: тёмно-зелёный блок + мокап с акцентом, преимущества, QR (светлый) и RuStore.
export default function MobileAppSection() {
  const { t } = useTranslation();

  return (
    <Box id="forwarding" bg="brand.8" c="white" pos="relative" className="on-dark" style={{ overflow: 'hidden' }}>
      <Petal color="var(--mantine-color-lime-4)" size={300} style={{ top: -100, right: -90, opacity: 0.14 }} />
      <Container size="lg" py={{ base: 'xl', md: 64 }} pos="relative">
        <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl" verticalSpacing="lg">
          <Stack gap="lg" justify="center">
            <Title order={2} c="white" fz={{ base: 22, sm: 30 }}>
              {t('landing.mobile.title')}
            </Title>
            <Text c="gray.2">{t('landing.mobile.text')}</Text>
            <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="md">
              {BENEFITS.map(({ key, icon }) => (
                <Group key={key} wrap="nowrap" align="flex-start" gap="sm">
                  <Image src={`/images/icons/${icon}.svg`} alt="" w={36} h={36} />
                  <Stack gap={2}>
                    <Text fw={600} c="white" size="sm">
                      {t(`landing.mobile.benefits.${key}.title`)}
                    </Text>
                    <Text size="sm" c="gray.3">
                      {t(`landing.mobile.benefits.${key}.text`)}
                    </Text>
                  </Stack>
                </Group>
              ))}
            </SimpleGrid>
            <Group gap="md" align="flex-start">
              <Box bg="white" p={6} style={{ borderRadius: 'var(--mantine-radius-md)' }} visibleFrom="xs">
                <Image src="/images/qr-code.png" alt={t('landing.mobile.qrAlt')} w={92} h={92} />
              </Box>
              <Anchor href={RUSTORE_URL} target="_blank" rel="noopener noreferrer" aria-label="RuStore">
                <Image src="/images/rustore.svg" alt="RuStore" h={44} w="auto" />
              </Anchor>
            </Group>
          </Stack>

          <Image src="/images/phones.webp" alt="" fit="contain" mah={440} />

        </SimpleGrid>
      </Container>
    </Box>
  );
}
